export enum AuthErrorCodes {
  INVALID_CODE = 'INVALID_CODE',
  INVALID_LOGIN = 'INVALID_LOGIN'
}

export enum AuthorizationErrorCodes {
  AUTHORIZATION_FAILED = 'AUTHORIZATION_FAILED',
  NOT_PERMITTED = 'NOT_PERMITTED'
}
